var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJoft4Lengeh2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 76 30",
    style: {
      enableBackground: "new 0 0 76 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10,15.4H7.3c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H10c0.3,0,0.5,0.2,0.5,0.5S10.3,15.4,10,15.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.5,11.4 9.5,18.4 13,14.9  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,30H0V0h76V30z M1,29h74V1H1V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9,25.3H4.4V4.4h11.5V25.3z M5.4,24.4h9.5v-19H5.4V24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6,15.4h-2.7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2.7c0.3,0,0.5,0.2,0.5,0.5S69.9,15.4,69.6,15.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.3,18.4 67.3,11.4 63.8,14.9  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4,25.3H61V4.4h11.5V25.3z M62,24.4h9.5v-19H62V24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5,30c-0.3,0-0.5-0.2-0.5-0.5V0.8c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v28.7 C39,29.8,38.7,30,38.5,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2,30c-0.3,0-0.5-0.2-0.5-0.5V0.8c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v28.7 C19.7,29.8,19.5,30,19.2,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3,30c-0.3,0-0.5-0.2-0.5-0.5V0.8c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v28.7C57.8,29.8,57.6,30,57.3,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9,15.2h-6.4c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h6.4c0.3,0,0.5,0.2,0.5,0.5S51.2,15.2,50.9,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7,18.5c-0.3,0-0.5-0.2-0.5-0.5v-6.7c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v6.7 C48.2,18.3,48,18.5,47.7,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4,15.2H26c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h6.4c0.3,0,0.5,0.2,0.5,0.5S32.7,15.2,32.4,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2,18.5c-0.3,0-0.5-0.2-0.5-0.5v-6.7c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v6.7 C29.7,18.3,29.5,18.5,29.2,18.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.7,
    y: 4.3,
    width: 38.1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.2,
    y: 25.2,
    width: 38.1,
    height: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoft4Lengeh2);
export default __webpack_public_path__ + "static/media/joft_4_lengeh_2.db1e21ddf243c3ab170a6eab6b6e4807.svg";
export { ForwardRef as ReactComponent };